module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segment"
  }, [_vm._v("\n\n  Top Preces ...\n\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-286cd47f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopGoodsPage.vue
// module id = 332
// module chunks = 1